<template>
    <div class="div">
        <button class="button is-small" :class="{'bold' : isFilled }" @click="openModal" style="min-width: 55px;">
            {{ carData.query.inspection }}
        </button>
        <div class="modal" :class="{'is-active': isActive }">
            <div class="modal-background" @click="isActive = !isActive"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Inspection: {{ carData.query.inspection }}</p>
                    <button class="delete" aria-label="close" @click="isActive = !isActive"></button>
                </header>
                <section class="modal-card-body">
                    <table class="is-fullwidth table is-bordered is-striped">
                        <thead>
                            <tr>
                                <th width="10">Select</th>
                                <th>Name</th>
                                <th>Info</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(inspection, index) in inspections">
                                <td width="10">
                                    <button class="button is-info" @click="selectInspection(inspection.name)">
                                        <span class="icon">
                                          <i class="fas fa-check"></i>
                                        </span>
                                    </button>
                                </td>
                                <td class="subtitle">{{ inspection.name }}</td>
                                <td>{{ inspection.info }}</td>
                                <td width="10">
                                    <button class="button is-danger" @click="deleteInspection(index, inspection)">
                                        <span class="icon">
                                          <i class="fas fa-trash"></i>
                                        </span>
                                    </button>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">
                                    <input v-model="newInspection.name" class="input" type="text" placeholder="Type name of the company">
                                </td>
                                <td>
                                    <input v-model="newInspection.info" class="input" type="text" placeholder="Type company info">
                                </td>
                                <td width="10">
                                    <button class="button is-primary" @click="createNewInspection">
                                        <span class="icon">
                                              <i class="fas fa-save"></i>
                                            </span>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </section>
                <footer class="modal-card-foot">
                    <button class="button"  @click="isActive = !isActive">Close</button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import apiInspections from './../../../api/apiInspections'
    import apiCars from './../../../api/apiCars'
    import moment from 'moment'
    export default {
        props:['car'],
        components: {

        },
        data () {
            return {
                isActive: false,
                inspections: [],
                carData:{
                    id: this.car.id,
                    query: {
                        inspection: this.car.inspection === null ? '---' : this.car.inspection,
                    }
                },
                newInspection: {
                    name: '',
                    info: ''
                }
            }
        },
        methods: {
            createNewInspection(){
               apiInspections
                    .createInspectionRequest(this.newInspection)
                    .then((response) => {
                        this.inspections.push(response.data)
                        this.newInspection.name = ''
                        this.newInspection.info = ''
                    })
                    .catch(error => console.log(error))
            },
            selectInspection(name) {
                this.carData.query.inspection = name
                apiCars
                    .updateCarRequest(this.carData)
                    .then((response) => {
                        this.isActive = false
                    })
                    .catch(error => console.log(error))
            },
            deleteInspection(index, port){
               apiInspections
                    .deleteInspectionRequest(port.id)
                    .then((response) => {
                        this.inspections = this.inspections.filter(item => item !== port)
                    })
                    .catch(error => console.log(error))
            },
            openModal() {
                this.isActive = !this.isActive
                apiInspections
                    .inspectionsListRequest()
                    .then((response) => {
                        this.inspections = response.data
                    })
                    .catch(error => console.log(error))
            }
        },
        computed: {
            isFilled() {
                if (this.carData.query.inspection !== '---'){
                    return  true;
                }
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Cars/Columns/InspectionColumn.vue